import axios from 'axios'

export default {
  data () {
    return {
      error: {
        user: {
          visible: false,
          code: 0,
          title: '',
          message: ''
        },
          technical: {
          visible: false,
          details: ''
        }
      },
      maintdialogVisible: false,
    }
  },
  created () {
    axios.interceptors.response.use(undefined, err => {
      if (err.response && err.response.headers && err.response.headers['x-cc-front-end-version']) {
        var minRequired = err.response.headers['x-cc-front-end-version'].split('/')[0]
        var minRecom = err.response.headers['x-cc-front-end-version'].split('/')[1]
        if (this.version < minRequired) {
          this.showForceRefresh = true
        }
        if (this.version < minRecom) {
          this.showRecommendRefresh = true
        }
      }
      var vm = this;
      function displayError ({ code = 0, title = 'Request Failed', message = 'An error occurred completing that request. If you are requesting a large export or running a long query, it may have timed out.', technical = 'Error Handled' }) {
        vm.error.user = {
          visible: true,
          code: code,
          title: title,
          message: message
        }
        vm.error.technical.details = technical
        throw err
      }
      if ((err.config) && (err.config.ignoreErrorHandle) && (err.config.ignoreErrorHandle === true || err.config.ignoreErrorHandle.includes(err.response.status))) {
        throw err
      }
      if (!err.response) {
        displayError({
          title: 'Connectivity Error',
          message: 'We were unable to connect to the API Server. Please check your connection and try again.',
          technical: 'Network Error'
        })
      } else {
        switch (err.response.status) {
          case 400:
            displayError({
              code: err.response.status,
              title: 'Bad Request',
              message: 'The API returned a bad request. Check your information and try again.',
              technical: err.request.response
            })
            break
          case 401:
            this.logOutAction()
              .then(() => {
                this.$router.push({ name: 'Login', query: { from: this.$route.fullPath } })
              })
            break
          case 403:
            displayError({
              code: err.response.status,
              title: 'Unauthorized',
              message: 'You do not have permission to complete that request. Contact support if you believe this is in error.',
              technical: err.request.response
            })
            break
          case 404:
            this.$router.push({ name: 'Error404', query: { from: this.$route.fullPath } })
            break
          case 405:
            displayError({
              code: err.response.status,
              title: 'Bad Method',
              message: 'The API Server could not handle the method of your request. Please try again, or contact support if this continues to occur.',
              technical: err.request.response
            })
            break
          case 500:
            displayError({
              code: err.response.status,
              title: 'Server Error',
              message: 'The API Server could not handle your request properly. Please try again, or contact support if this continues to occur.',
              technical: err.request.response
            })
            break
          case 503:
            this.maintdialogVisible = true
            break
          default:
            displayError({
              title: "Request Failed",
              message: "An error occurred completing that request. If you are requesting a large export or running a long query, it may have timed out. Try reducing the size of your query and try again.",
              technical: err.request.response
            })
        }
      }
      throw err
    })
  }
}
